<div style="display: flex; align-items: center;">
   <mat-icon>check</mat-icon>
    <div>
      <span>{{ data}}</span>
    </div>
  </div>
  